import type { ReactElement } from "react";

import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";

import type { SignalType } from "app/pages/sales-intelligence/domain/signals/types/signal";

import { getIconForSignalType } from "../../constants/signalTypeIcons";

import { StyledSignalTypeChip, StyledSignalTypeIconBadge, StyledSignalTypeLabel } from "./styles";

type SignalTypeChipProps = {
    readonly signalType: SignalType;
    /** Translated by the caller: this module owns the signal type, not the copy shown for it. */
    readonly label: string;
    readonly dataAutomation?: string;
};

/** Read-only marker for a signal type — an icon badge and a label, with no interaction. */
export const SignalTypeChip = ({ signalType, label, dataAutomation }: SignalTypeChipProps): ReactElement => {
    return (
        <StyledSignalTypeChip
            inline
            alignItems="center"
            data-automation={dataAutomation}
        >
            <StyledSignalTypeIconBadge
                alignItems="center"
                justifyContent="center"
            >
                <SWReactIcons
                    iconName={getIconForSignalType(signalType)}
                    size="xs"
                    iconColor={colorsPalettes.carbon[300]}
                />
            </StyledSignalTypeIconBadge>

            <StyledSignalTypeLabel>{label}</StyledSignalTypeLabel>
        </StyledSignalTypeChip>
    );
};
